/**
 * Logger utility that only logs in development mode
 * In production, logs are suppressed to avoid exposing sensitive information
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
    // In production, you might want to send warnings to error tracking service
    // Example: errorTrackingService.captureWarning(args);
  },

  error: (...args: unknown[]) => {
    // Always log errors, but in production send to error tracking service
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, send to error tracking service (e.g., Sentry, LogRocket)
      // Example: errorTrackingService.captureException(args);
      console.error(...args); // Keep for now, but should be replaced with error service
    }
  },

  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};
